module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container",
    style: (_vm.rootStyle)
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2018 Geekbang Technology Ltd. All rights reserved. 极客邦控股（北京）有限公司 | 京ICP备16027448号-3. ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "items"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.geekbang.org/aboutus"
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.geekbang.org/recruit"
    }
  }, [_vm._v("加入我们")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.geekbang.org/ivtw"
    }
  }, [_vm._v("关注我们")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.geekbang.org/partner"
    }
  }, [_vm._v("合作伙伴")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://service.geekbang.org"
    }
  }, [_vm._v("企业服务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footcard"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('i', {
    staticClass: "icon-font"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("业务合作"), _c('br'), _vm._v("hezuo@geekbang.org"), _c('br'), _vm._v("\n        电话：010-64738140\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('i', {
    staticClass: "icon-font"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("内容合作"), _c('br'), _vm._v("content@geekbang.org")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('i', {
    staticClass: "icon-font"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("反馈投诉"), _c('br'), _vm._v("feedback@geekbang.org")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('i', {
    staticClass: "icon-font"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("公司电话"), _c('br'), _vm._v("010-64738142")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-520c4cf5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/geekbang-base/src/components/footer/Footer.vue
// module id = 449
// module chunks = 1